import ReactGA from 'react-ga4';

const {location, console} = window;

export default {
  buffer: [],
  pageviews: [],
  initialized: false,
  trackers: null,
  toolkey: null,

  init(...trackers) {
    this.toolkey = location.hostname.split('.').shift();

    // Filter out empty strings since API can return empty uaCode
    this.trackers = trackers.reduce((memo, id) => {
      if (id) memo.push(id);
      return memo;
    }, []);

    // Log an error when no tracker code provided
    if (!this.trackers.length || !this.trackers[0]) console.error('No UA code');

    // Initialize
    this.trackers.map((code, index) => {
      const name = `tracker_${index}`;
      ReactGA.initialize(code, {
        gaOptions: {
          name,
          sampleRate: 100,
          anonymizeIp: true,
          cookieFlags: 'samesite=none;secure'
        }
      });

      return name;
    });

    this.initialized = true;

    // Always send a pageview with current URL on load
    this.sendToAllTrackers('pageview', {
      hitType: 'pageview',
      page: `${location.pathname}${location.search || ''}`,
      title: document.title,
    });

    // Any events sent while the trackers were not ready are fired now
    this.sendBufferedEvents();
    this.sendBufferedPageViews();
  },

  sendPageview(url) {
    if (!this.initialized) return this.pageviews.push([url]);
    return this.sendToAllTrackers('pageview', {
      hitType: 'pageview',
      page: url,
      title: document.title,
    });
  },

  sendBufferedPageViews() {
    while (this.pageviews.length) this.sendPageview(...this.pageviews.shift());
  },

  send(event, detail) {
    if (!this.initialized) return this.buffer.push([event, detail]);

    return this.sendToAllTrackers('event', {
      category: this.toolkey,
      action: event,
      label: detail,
    });
  },

  sendToAllTrackers(type, event) {
    this.trackers.forEach(() => {
      if (ENV.RELEASE_STAGE === 'development') {
        console.debug('GA SEND: ', type, event);
        return;
      }

      if (type === 'pageview') {
        ReactGA.send(event);
        return;
      }

      ReactGA.event({...event, action: type});
    });
  },

  sendBufferedEvents() {
    while (this.buffer.length) this.send(...this.buffer.shift());
  },
};
